import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SeoService {
  private $html: HTMLElement
  private $title: HTMLElement
  private $metaDescription: HTMLElement
  private $canonical: HTMLElement

  constructor() {
    this.$html = document.querySelector('html')!
    this.$title = document.querySelector('head > title')!
    this.$metaDescription = document.querySelector('head > meta[name="description"]')!
    this.$canonical = document.querySelector('head > link[rel="canonical"]')!
  }

  public setTitle(title: string): void {
    if (this.$title) this.$title.textContent = title
  }

  public setMetaDescription(description: string): void {
    if (this.$metaDescription) this.$metaDescription.setAttribute('content', description)
  }

  public setCanonical(href: string): void {
    if (this.$canonical) this.$canonical.setAttribute('href', href)
  }

  public setHtmlLang(lang: string): void {
    if (this.$html) this.$html.setAttribute('lang', lang)
  }
}
